import { GlobalSurveyTemplate, SurveyData } from "../..";
import { surveySegmentationObjectValidation, SurveySegmentationObjectValidationResult } from './surveySegmentationObjectValidation';
import { surveyThemeObjectValidation, SurveyThemeObjectValidationResult } from "./surveyThemeObjectValidation";
import { fieldValidation } from '../fieldValidation/fieldValidation';
import { surveyValidation } from "../fieldValidation/fields/surveyFieldValidation";

export type GlobalSurveyTemplateValidationResult =
    'invalid_globalSurveyTemplate' |
    'invalid_globalSurveyTemplate_category' |
    'invalid_globalSurveyTemplate_description' |
    'invalid_globalSurveyTemplate_title' |
    SurveyObjectValidationResult;

export type SurveyObjectValidationResult =
    'invalid_survey' | 
    'invalid_survey_type' | 
    'invalid_survey_languageCode' |
    'invalid_survey_translationLanguages' |
    'invalid_survey_introduction' |
    'invalid_survey_segmentations' |
    'invalid_survey_themes' | 
    SurveyThemeObjectValidationResult | 
    SurveySegmentationObjectValidationResult;

function validateSurvey(survey:SurveyData): SurveyObjectValidationResult
{
    if(survey === null || survey === undefined || typeof survey !== 'object')
        return 'invalid_survey';

    const allowedKeys = ['id', 'activityId', 'type', 'introduction', 'languageCode', 'translationLanguages', 'segmentations', 'themes'];
    if(Object.keys(survey).find(k => !allowedKeys.includes(k)))
        return 'invalid_survey';
    
    if(!surveyValidation.survey.type(survey.type))            
        return 'invalid_survey_type';

    // Valid language set
    if(!surveyValidation.survey.language(survey.languageCode))
        return 'invalid_survey_languageCode';

    // Valid translation languages
    if(!surveyValidation.survey.translationLanguages(survey.translationLanguages))
        return 'invalid_survey_translationLanguages';

    // Current language not in translation languages
    if(survey.translationLanguages.includes(survey.languageCode))
        return 'invalid_survey_translationLanguages';


    if(!surveyValidation.survey.introduction(survey.translationLanguages, survey.introduction))
        return 'invalid_survey_introduction';



    const segmentValidation = surveySegmentationObjectValidation.segmentationList(survey.segmentations, survey.translationLanguages);
    if(segmentValidation !== 'valid')
        return segmentValidation;

    const themeValidation = surveyThemeObjectValidation.validateThemeList(survey.themes, survey.translationLanguages);
    if(themeValidation !== 'valid')
        return themeValidation;

    return 'valid';
}

function validateGlobalTemplate(template:GlobalSurveyTemplate)
    : GlobalSurveyTemplateValidationResult
{
    if(!template)
        return 'invalid_globalSurveyTemplate';

    if(!fieldValidation.surveyTemplate.category(template.category))
        return 'invalid_globalSurveyTemplate_category';

    if(!fieldValidation.surveyTemplate.description(template.description))
        return 'invalid_globalSurveyTemplate_description';

    if(!fieldValidation.surveyTemplate.title(template.title))
        return 'invalid_globalSurveyTemplate_title';

    const surveyValidation = validateSurvey({
        activityId: '0',
        id: '0',
        introduction: template.introduction,
        languageCode: template.languageCode,
        translationLanguages: template.translationLanguages,
        segmentations: template.segmentations,
        themes: template.themes,
        type: 'WPA'
    } satisfies SurveyData);

    if(surveyValidation !== 'valid')
        return surveyValidation;

    if(!template.themes || template.themes.length === 0)
        return 'invalid_theme';

    if(template.themes.some(t => !t || !t.questions || t.questions.length === 0))
        return 'invalid_theme';

    return 'valid';
}

export const surveyObjectValidation = {
    validateSurvey,
    validateGlobalTemplate
};
